// import { LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */

// const stagingUrl = 'https://gray-bay-026ad6100.6.azurestaticapps.net'
// const devUrl = "http://localhost:3000"

export const msalConfig = {
  auth: {
    clientId: "6b99316a-e453-4519-ba30-ec4f4e47a805",
    authority: "https://login.microsoftonline.com/redeemer.com.au",
    // redirectUri: "https://go.redeemer.com.au",
    redirectUri: "https://godev.redeemer.com.au",
    // redirectUri: 'https://gray-bay-026ad6100.6.azurestaticapps.net',
    // redirectUri: "http://localhost:3000",
  },
  cache: {
    cacheLocation: "sessionStorage",
    // cacheLocation: "localStorage",
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
      },
    },
  },
};

export const loginRequest = {
  scopes: [
    "User.Read",
    // "User.Read.All",
    // "Group.Read.All",
    // "GroupMember.Read.All",
  ],
};

export const protectedRequest = {
  scopes: ["api://6b99316a-e453-4519-ba30-ec4f4e47a805/access_as_user"],
};

//-------SERVER URLS

export const serverUrl = "https://goredeemer-f4aqdjd2crafekeh.australiaeast-01.azurewebsites.net";

// export const serverUrl = "http://localhost:4000";

export const storageEndpoint = "https://storagerlc.blob.core.windows.net";

export const graphEndpoint = "https://graph.microsoft.com/v1.0/me";
